import { useQuery } from '@tanstack/react-query'
import type { PbFindProcessesRequest } from '@itsrever/rever-api'
import { findProcesses } from '@/api/processes-api'

export const useProcesses = (filters: PbFindProcessesRequest) => {
  return useQuery({
    queryKey: ['processes', filters],
    queryFn: ({ signal }) =>
      findProcesses({ pbFindProcessesRequest: filters }, signal),
    placeholderData: (prev) => prev
  })
}
